import { createFileRoute } from '@tanstack/react-router';

import { NetworkEditorPage } from '../features/admin/networks/components/NetworkEditorPage';

export const Route = createFileRoute('/networks/create')({
  component: NetworkEditorPage,
});
